import classNames from "classnames";
import type { FC, PropsWithChildren } from "react";
import { Link as InternalLink } from "react-router";
import { externNavigering, type LinkProps } from "./Link";

const WebLink: FC<PropsWithChildren<LinkProps>> = ({ to, className, onClick, children, "data-testid": dataTestId, type, state }) => {
	const props = {
		onClick,
		className: classNames("ffe-link-text", className),
		target: externNavigering(to, type) ? "_blank" : undefined,
		rel: "noopener noreferrer",
		type,
		"data-testid": dataTestId, // Add this
		state,
	};
	if (externNavigering(to, type)) {
		return (
			<a href={to} {...props}>
				{children}
			</a>
		);
	}

	return (
		<InternalLink to={to} {...props}>
			{children}
		</InternalLink>
	);
};
export default WebLink;
